module.exports = __webpack_public_path__ + "static/media/ftn-pop-auth.324bf05d.svg";